import React, { useState } from "react";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import logo from "../assets/images/logo/Header-logo.jpeg";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const COLORS = {
    bgPrimary: "rgba(10,10,10,0.7)",
    gold: "#E6C07B",
    white: "#FFFFFF",
  };

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about-us" },
    {
      name: "Services",
      isDropdown: true,
      subLinks: [
        { name: "Civil Cases", href: "/services/civil-cases" },
        { name: "Criminal Cases", href: "/services/criminal-cases" },
        { name: "Matrimonial Cases", href: "/services/matrimonial-Cases" },
        { name: "Domestic Violence", href: "/services/domestic-violence" },
        { name: "Divorce Cases", href: "/services/divorce-cases" },
        { name: "Recovery of Money", href: "/services/recovery-of-money" },
        { name: "Partnership Matter", href: "/services/partnership-matters" },
        { name: "Property Disputes", href: "/services/property-disputes" },
        {
          name: "Negotiable Instrument Act Cases",
          href: "/services/negotiable-instrument-act-cases",
        },
        {
          name: "Environmental Matters",
          href: "/services/environmental-matters",
        },
        { name: "Bail Trial", href: "/services/bail-trial" },
        {
          name: "Company Related Issue",
          href: "/services/company-related-issue",
        },
        { name: "Cyber Cases", href: "/services/cyber-cases" },
      ],
    },
    { name: "Blog", href: "/blogs" },
    { name: "Contact Us", href: "/contact-us" },
  ];

  return (
    <header
      className="fixed top-0 left-0 w-full z-50 backdrop-blur-xl"
      style={{ background: COLORS.bgPrimary }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <img src={logo} alt="Logo" className="h-10 md:h-12" />

          {/* Desktop Nav */}
          <nav className="hidden xl:flex items-center gap-8 text-white">
            {navLinks.map((link) => (
              <div key={link.name} className="relative">
                {link.isDropdown ? (
                  <div className="relative group">
                    <button className="flex items-center gap-1 text-sm uppercase hover:text-[#E6C07B]">
                      {link.name}
                      <FaChevronDown size={12} />
                    </button>

                    {/* FIX: proper hover dropdown */}
                    <div className="absolute top-8 left-0 w-56 rounded-xl bg-black/90 backdrop-blur-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 p-2">
                      {link.subLinks.map((sub) => (
                        <a
                          key={sub.name}
                          href={sub.href}
                          className="block px-4 py-2 text-sm text-white hover:text-[#E6C07B] hover:bg-white/10 rounded-lg"
                        >
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  </div>
                ) : (
                  <a
                    href={link.href}
                    className="text-sm uppercase hover:text-[#E6C07B]"
                  >
                    {link.name}
                  </a>
                )}
              </div>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden xl:block">
            <a
              href="/contact-us"
              className="px-5 py-2 text-sm font-semibold rounded-full"
              style={{ background: COLORS.gold, color: "black" }}
            >
              Consult Now
            </a>
          </div>

          {/* Mobile */}
          <div className="xl:hidden text-white">
            <button onClick={toggleMenu}>
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="xl:hidden bg-black/95 text-white">
          <div className="px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <div key={link.name}>
                {link.isDropdown ? (
                  <>
                    <button
                      className="w-full flex justify-between uppercase"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      {link.name} <FaChevronDown />
                    </button>

                    {isDropdownOpen && (
                      <div className="pl-4 mt-2 space-y-2">
                        {link.subLinks.map((sub) => (
                          <a
                            key={sub.name}
                            href={sub.href}
                            className="block text-sm text-white"
                          >
                            {sub.name}
                          </a>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <a href={link.href} className="block uppercase">
                    {link.name}
                  </a>
                )}
              </div>
            ))}

            <a
              href="/contact-us"
              className="block text-center py-3 rounded-full font-semibold"
              style={{ background: COLORS.gold, color: "black" }}
            >
              Consult Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
